import { spacing } from '@akin-home/theme';
import React from 'react';
import { Image, Pressable, Text, View } from 'react-native';
import { getRobotImgFromType } from '../../utils';
import { RobotDevice } from '../../types';

type NearbyRobotItemProps = {
  robotDevice: RobotDevice;
  onSelect: () => void;
  isSelected: boolean;
  itemDiameter?: number;
};

export const NearbyRobotItem = (props: NearbyRobotItemProps) => {
  const itemDiameter = props.itemDiameter ?? 200;

  return (
    <Pressable
      style={{
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        margin: spacing[2],
      }}
      onPress={() => props.onSelect()}
    >
      <View
        style={{
          height: itemDiameter,
          width: itemDiameter,
          borderRadius: itemDiameter / 2,
          overflow: 'hidden',
          padding: spacing[3],
          borderWidth: props.isSelected ? 8 : 4,
          borderColor: props.isSelected ? '#535af1' : 'black',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <View
          style={{
            height: itemDiameter - spacing[4] * 2,
            width: itemDiameter - spacing[4] * 2,
            borderRadius: (itemDiameter - spacing[4] * 2) / 2,
            backgroundColor: '#ffbf09',
            flexDirection: 'column',
          }}
        >
          <Image
            style={{
              overflow: 'hidden',
              flex: 1,
              alignItems: 'center',
              width: '100%',
            }}
            source={getRobotImgFromType(props.robotDevice.type)}
          />

          <Text
            style={{
              fontSize: 20,
              color: 'black',
              alignSelf: 'center',
              marginBottom: spacing[2],
            }}
            adjustsFontSizeToFit
            numberOfLines={1}
          >
            {props.robotDevice.name}
          </Text>
        </View>
      </View>
    </Pressable>
  );
};
